<template>
  <div>
    <v-data-table
      :headers="headers"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
      no-data-text=""
    >
      <template v-slot:body.prepend>
        <tr>
          <td>
            <v-spacer />
          </td>
          <td>
            <v-select
              v-model="filters.period"
              append-icon="mdi-calendar"
              :label="$t('DATA_TABLE.FILTER')"
              :items="dates"
              menu-props="auto"
            ></v-select>
          </td>
          <td>
            <div class="d-flex">
              <v-spacer class="mx-1"></v-spacer>
              <v-btn color="primary" depressed @click.prevent="refreshData">
                {{ $t('BUTTON.FIND') }}
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { yearFormat, dateFormatBackend } from '@/modules/_global/filters';
import moment from 'moment/moment';
import { isEqual } from 'lodash';
import { generateYears } from '@/modules/holidays/common/utils';

export default {
  name: 'HolidaysListFilter',

  filters: {
    yearFormat,
    dateFormatBackend
  },

  components: {},

  props: {
    value: {
      type: Object,
      default: () => ({ period: moment().year() })
    }
  },

  data() {
    return {
      filters: {},
      period: dateFormatBackend(),
      dates: []
    };
  },

  computed: {
    headers() {
      return [
        {
          text: ''
        },
        {
          text: this.$t('ITEM.YEAR'),
          value: 'period',
          width: '200px'
        },
        {
          text: '',
          width: '100px'
        }
      ];
    }
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    }
  },

  created() {
    this.dates = generateYears(moment().year() + 6, moment().year() - 5);
  },

  methods: {
    valueWatchHandler(formProps) {
      if (isEqual(formProps, this.filters)) {
        return;
      }

      this.filters = {
        ...this.filters,
        ...formProps
      };
    },

    refreshData() {
      this.$emit('setRequest', { ...this.filters });
    }
  }
};
</script>
